module.exports = __webpack_public_path__ + "img/mccbSurvey.345b0e87.png";